// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_URL: "https://mi.api.bocadelrio.gob.mx/api",
  API_KEY: 'AIzaSyDPdZBKDF1fo7cK8eyRA-6C0MF3OZ1vU_k',
  //API_KEY: 'AIzaSyBNjatX13mEqTPnVwnfd2nbpC_QCq1tlk0',
};
